@if (!isViewingFullInsightsPage) {
  <dgx-breadcrumbs [breadcrumbs]="breadcrumbs"></dgx-breadcrumbs>
}
@if (!!links && !permissions.isTrackableLinksDisabled) {
  <section
    [ngClass]="{
      'box-shadow rounded--large guts-p-full-2': isViewingFullInsightsPage,
    }"
  >
    <dgx-tracking-links-table
      [inviteUrl]="pathway.inviteUrl"
      [links]="links"
      [canManage]="canManagePathwayTrackableLinks"
      [isOrgContent]="isOrgContent"
      [currentSortBy]="currentSortBy"
      [ascend]="ascend"
      (onDelete)="handleDeleteLink($event)"
      (onEdit)="handleEditLink($event)"
      (onNew)="handleNewLink()"
      (onSort)="onSort($event)"
    >
      @if (isViewingFullInsightsPage) {
        <header>
          <h3 class="h3 table-title">
            {{ i18n.TrackableLinkCtrl_AutoEnroll }}
          </h3>
        </header>
      } @else {
        <header class="guts-p-t-5 guts-p-b-1 guts-p-l-1">
          <h1 class="h1 break">{{ i18n.TrackableLinkCtrl_Title }}</h1>
        </header>
      }
    </dgx-tracking-links-table>
  </section>
}
